import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { Form } from "../components/general/form.js"; 
import { useAuth } from "../context/authContext";

export default function ResetPassword() {
  const { requestResetPassword } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "" });


  const handlePasswordReset = async () => {
    if (!formData.email) {
      toast.error("Please enter your email.");
      return;
    }

    setLoading(true);
    try {
      const normalizedEmail = (formData.email || "").trim().toLowerCase();
      await requestResetPassword({ email: normalizedEmail });
      toast.success("Recovery email sent. Please check your inbox.");
    } catch (error) {
      toast.error(`Failed to send recovery email: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const formFields = [
    {
      type: "text",
      name: "email",
      label: "Email",
      placeholder: "Enter email",
      value: formData.email,
      required: true,
      onChange: (e) => setFormData({ ...formData, email: e.target.value }),
    },
  ];

  return (
    <div className="relative h-screen w-screen flex flex-col items-center justify-center bg-primary-light">

      {/* <div className="absolute z-20 top-32">
        <img src={require("../assets/images/logo-white.png")} alt="NanoWattz Logo" width={250} />
      </div> */}

      {/* Reset Password Form */}
      <div className="relative bg-white p-8 rounded-xl shadow-xl w-full max-w-md z-20 bg-opacity-90">
        <h2 className="text-center font-nexa text-2xl font-bold text-primary-dark mb-6">Reset Password</h2>
        <Form
          fields={formFields}
          onSubmit={handlePasswordReset}
          formData={formData}
          setFormData={setFormData}
          btnText="Send Recovery Email"
          isLoading={loading}
          className="bg-opacity-50"
        />
        <div className="mt-3">
          <p className="text-left font-nexa w-full text-primary-dark">
            Remembered your password?{" "}
            <a className="text-primary hover:text-primaryDull decoration-transparent" href="/">
              Back to Login
            </a>
          </p>
        </div>
      </div>

      <div className="absolute z-20 bottom-5">
        <p className="font-nexa w-full text-center text-white">
          All rights reserved{" "}
          <a className="text-white hover:text-primaryDull decoration-transparent" href="/about" target="_blank">
            THE GRID 1.0
          </a>
        </p>
      </div>
      <Toaster position="top-center" />
    </div>
  );
}
